import CitySEOHead from "@/components/feature/CitySEOHead";
import ArizonaHeroSection from "./components/HeroSection";
import ArizonaCitiesDirectory from "./components/CitiesDirectory";
import ArizonaCommunitiesWeServe from "./components/CommunitiesWeServe";
import ArizonaStateResources from "./components/StateResources";
import ArizonaFAQSection, { faqs } from "./components/FAQSection";
import ArizonaFinalCTA from "./components/FinalCTA";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";

const arizonaFaqs = faqs.map((f: { question: string; answer: string }) => ({ q: f.question, a: f.answer }));

const arizonaServices = [
  { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
  { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
  { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
  { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
  { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
  { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  { name: "Second Passport & Damaged", description: "Second passport issuance for frequent travelers and damaged passport replacement." },
];

export default function ArizonaPage() {
  return (
    <>
      <CitySEOHead
        city="Arizona"
        state="Arizona"
        stateAbbr="AZ"
        route="/states/arizona"
        title="Arizona Passport Services — Expedited & Emergency | Fast Passport Center"
        description="Expedited passport services across Arizona — Phoenix, Tucson, Scottsdale, Flagstaff, Mesa, Chandler. Emergency processing as fast as 24 hours. A+ BBB rated courier service."
        geoPlacename="Arizona, United States"
        geoPosition="34.0489;-111.0937"
        faqs={arizonaFaqs}
        servicesSchema={arizonaServices}
      />
      <div className="font-sans">
        <ArizonaHeroSection />
        <ArizonaCitiesDirectory />
        <ArizonaCommunitiesWeServe />
        <ArizonaStateResources />
        <ArizonaFAQSection />
        <SEOCrossLinks state="AZ" />
        <ArizonaFinalCTA />
      </div>
    </>
  );
}